// extracted by mini-css-extract-plugin
module.exports = {"content":"Hotkeys_content__3D1t_","entries":"Hotkeys_entries__2KSzG"};